import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import styled from 'styled-components';
import ds from 'designsystem';
import { media } from 'common/responsive';
import Cookies from 'universal-cookie';
import Bind from 'lodash-decorators/bind';

import COOKIE_KEY from 'common/consts/cookies';
import Paragraph from 'elements/Paragraph';

/* eslint-disable react/prop-types */

const CookiesModalBox = styled.div`
    width:100%;
    padding: ${ds.get('metrics.m')};
    background-color: ${ds.brand('text')};
    position: fixed;
    z-index:1000;
    bottom:0;
    
    ${media.desktop`
        right: ${ds.get('metrics.l')}
        width: 500px;
        height: auto;
        bottom: 250px;
    `};
`;

const CloseIcon = styled.a`
    display: block;
    position: absolute;
    width: 25px;
    height: 25px;
    top: 15px;
    right: ${ds.get('metrics.s')};
    cursor: pointer;
    &:before, &:after {
        display: block;
        content: '';
        position: absolute;
        right: 12px;
        height: 25px;
        width: 1px;
        background-color: ${ds.brand('background')};
    }
    &:before {
        transform: rotate(45deg);
    }
    &:after {
        transform: rotate(-45deg);
    }
`;

const WhiteParagraph = styled(Paragraph)`
    color: ${ds.brand('background')};
    font-size: ${ds.fs('s')};
    line-height: 21px;
`;

@inject('coreStore')
@observer
export default class CookiesModal extends Component {
  constructor(props) {
    super(props);
    this.cookieProvider = new Cookies();
  }

  state = {
    hasCookie: false,
  };

  componentDidMount() {
    this.setState({ hasCookie: this.cookieProvider.get(COOKIE_KEY) });
  }

  @Bind
  setCookie() {
    this.cookieProvider.set(COOKIE_KEY, true);
    this.setState({ hasCookie: true });
  }

  render() {
    const {
      coreStore: {
        translations,
      },
    } = this.props;

    const { hasCookie } = this.state;

    return hasCookie
      ? null : (
        <CookiesModalBox>
          <WhiteParagraph>
            {translations.COOKIES_AGREEMENT}
          </WhiteParagraph>
          <CloseIcon onClick={this.setCookie} />
        </CookiesModalBox>
      );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/CookiesModal/CookiesModal.jsx